import Image from "next/image";
import Input from "./Input";
import AmountItem from "../Invoice/AmountItem";
import LineItem from "../Invoice/LineItem";
import ButtonPrimary from "../../Button/ButtonPrimary";
import styles from "./style.module.css";
import { useContext, useEffect, useState } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { currencyFormatter } from "../../../utils/format";
import { prepareDataValidate } from "../util";
import AppContext from "../../../store/AppContext";
import { createBrankingCode, createOrder, getPaymentMethod } from "../../../pages/api/cart";
import { TRsponseCreateOrder } from "../../../@types/cart";
import { useRouter } from "next/router";
import environment from "../../../utils/environment";
import { CheckCircleFilled, CheckOutlined } from "@ant-design/icons";
import { notification } from "antd";
import browserStored from "../../../utils/browserStored";
import { STORAGE_KEYS } from "../../../utils/config";
import { ICustomerAppContext } from "../../../@types/IContext/IPaymentContext";
import dayjs from "dayjs";
import moment from "moment";

const PaymentInfo = ({ setLoading }: any) => {
    const [paymentMethod, setPaymentMethod] = useState<any>(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [api, contextHolder] = notification.useNotification();

    const router = useRouter();

    const { generalSetting, holidays, workingDay } = useContext(AppContext)
    const {
        rentTotal,
        rentSurchargeFee,
        rentTransportFee,
        rentDepositFee,

        sellTotal,
        sellTransportFee,
        sellSurchargeFee,
        sellDepositFee,
        discountFee,
        rentCustomer,
        sellCustomer,

        sellCarts,
        rentCarts,

        rentAdditionalInformation,
        sellAdditionalInformation,

        setOrderSuccess,
        setCurrentStep,
        currentStep,
    } = useContext(PaymentContext);

    const rent = (rentTotal ?? 0)
        + (rentDepositFee ?? 0)
        + (rentSurchargeFee ?? 0)
        + (rentTransportFee ?? 0)

    const sell = (sellTotal ?? 0)
        + (sellDepositFee ?? 0)
        + (sellSurchargeFee ?? 0)
        + (sellTransportFee ?? 0)

    const handleSubmitOrder = async () => {
        await setLoading(true)
        if (!paymentMethod) {
            api.warning({
                message: `Thông báo`,
                description: 'Vui lòng chọn phương thức thanh toán',
                duration: 4,
            });

            await setLoading(false)
            return;
        }

        //let cloneCustomer: ICustomerAppContext | any = { ...customer };
        // if (cloneCustomer.birthday) {
        //     cloneCustomer.birthday = dayjs(cloneCustomer.birthday).format("YYYY-MM-DD");
        // }

        let initData: any = {
            customer: sellCustomer,
            total_order: 0,
        }
        let cloneRentCarts = rentCarts.filter((item: any) => {
            if (item.checked == true && !item.allowed_split) {
                return true
            }
            if (item.allowed_split) {
                return true
            }
            return false
        });
        let cloneSellCarts = sellCarts.filter((item: any) => {
            if (item.checked == true && !item.allowed_split) {
                return true
            }
            if (item.allowed_split) {
                return true
            }
            return false
        });
        let sellData = prepareDataValidate(workingDay, holidays, cloneSellCarts, generalSetting, false, false, true);
        //console.log("sellData", sellData);
        if (sellData?.length > 0) {
            initData.purchase_product = {
                delivery_fee: sellTransportFee,
                order_amount: sellTotal,
                actual_amount: sell,
                insurance_money: 0,
                late_return_fee: 0,
                discount: 0,
                product_details: sellData?.map((item: any) => {

                    item.received_date = item.received_date ? moment(item.received_date).format("YYYY-MM-DD") : null;
                    item.return_date = item.return_date ? moment(item.return_date).format("YYYY-MM-DD") : null;
                    return item;
                }),
                customer: {
                    address: sellCustomer.address,
                    email: sellCustomer.email,
                    note: sellCustomer.note,
                    name: sellCustomer.name,
                    phone: sellCustomer.phone,
                },
                additional_information: {
                    ...sellAdditionalInformation,
                    transaction_type: paymentMethod?.type
                },
                payment_method_id: paymentMethod?.id,
            }
        }
        //console.log('init', initData);

        let rentData = prepareDataValidate(workingDay, holidays, cloneRentCarts, generalSetting, true, false, true)
        if (rentData?.length > 0) {

            initData.rent_product = {
                delivery_fee: rentTransportFee,
                order_amount: rentTotal,
                actual_amount: rent,
                insurance_money: rentDepositFee,
                late_return_fee: rentSurchargeFee,
                discount: 0,
                product_details: rentData?.map((item: any) => {
                    item.received_date = item.received_date ? moment(item.received_date).format("YYYY-MM-DD") : null;
                    item.return_date = item.return_date ? moment(item.return_date).format("YYYY-MM-DD") : null;

                    return item;
                }),
                customer: {
                    address: rentCustomer.address,
                    email: rentCustomer.email,
                    note: rentCustomer.note,
                    name: rentCustomer.name,
                    phone: rentCustomer.phone,
                },
                additional_information: {
                    ...rentAdditionalInformation,
                    transaction_type: paymentMethod?.type
                },
                payment_method_id: paymentMethod?.id,
            }
        }

        const responseCreateOrder = await createOrder(initData);

        if (!responseCreateOrder?.order_code) {
            api.warning({
                message: `Thông báo`,
                description: 'Có lỗi xãy ra trong quá trình tạo đơn hàng. Vui lòng thử lại sau',
                duration: 4,
            });
            await setLoading(false);

            return;
        }

        if (paymentMethod.bank_code?.toUpperCase() === 'COD') {
            await setLoading(false);
            await setOrderSuccess(responseCreateOrder);
            await setCurrentStep(3)
            // browserStored.removeLocalStored(STORAGE_KEYS.PAYMENT);
            return router.push('/order-success');
        }

        if (paymentMethod.bank_code?.toLowerCase() === 'zalopayapp') {
            const callApiCreateOrder: TRsponseCreateOrder | null = await createBrankingCode({
                method_id: paymentMethod?.id,
                order_code: responseCreateOrder.order_code,
            })

            await setLoading(false);

            if (callApiCreateOrder !== null) {
                router.push(callApiCreateOrder.order_url);
            }
        }

        await setLoading(false);
        await setOrderSuccess(responseCreateOrder);
        await setCurrentStep(3)
        return router.push('/order-success');

    }

    useEffect(() => {
        getPaymentMethod().then((response) => {
            setPaymentMethods(response);
        })
    }, [])

    return (
        <div className="cart-box rounded " style={{ minHeight: '75vh' }}>
            {contextHolder}
            <div className="px-4 relative h-full">
                <div className="heading line-bottom text-lg uppercase">
                    Thông tin thanh toán
                </div>

                <div className="mt-4 h-full">
                    <div className="flex flex-col justify-between content-payment-info">
                        <div className=" grid md:grid-cols-2 lg:grid-cols-4 sm:grid-cols-3 grid-cols-3 gap-4">
                            {
                                paymentMethods.map((item: any, index: number) => {
                                    return (
                                        <div key={index}
                                            style={{
                                                width: '100%',
                                                whiteSpace: 'break-spaces'
                                            }}

                                            className="relative cursor-pointer"
                                            onClick={() => {
                                                setPaymentMethod(item)
                                            }}
                                        >
                                            {
                                                paymentMethod?.id === item?.id && (
                                                    <div className="absolute right-3 top-2">
                                                        <CheckCircleFilled color={"yellow"} style={{ color: '#36CFC9' }} rev={undefined} />
                                                    </div>
                                                )
                                            }
                                            <div className={styles.paymentTransactionItem}>
                                                <Image
                                                    src={environment.baseImageUrl + item.image_url}
                                                    alt={item?.alt}
                                                    title={item?.alt}
                                                    width={50}
                                                    height={50}
                                                    style={{ width: 50, height: 50 }}
                                                />
                                            </div>
                                            <span className={styles.paymentTransactionItemLabel}>{item.name}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div>
                            <div className="mt-4">
                                <Input />
                            </div>

                            <div className="mt-4">
                                <LineItem className="my-4" />
                                <AmountItem
                                    label={'Tổng đơn thuê'}
                                    value={rent}
                                />
                                <AmountItem
                                    label={'Tổng đơn mua'}
                                    value={sell}
                                />
                                <AmountItem label={'Giảm giá'} value={discountFee ?? 0} />
                                <AmountItem label={'Chiết khấu'} value={0} />
                            </div>

                            <div className="my-4">
                                <ButtonPrimary className={'w-full cursor-pointer'} onClick={handleSubmitOrder}>
                                    <div className="flex justify-between items-center">
                                        <label className="cursor-pointer">{currencyFormatter.format(rent + sell)}</label>
                                        <div className="flex gap-2">
                                            <label className="cursor-pointer">Thanh toán</label>
                                            <svg width={25} height={25} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                <rect width={25} height={25} fill="url(#pattern0)" />
                                                <defs>
                                                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width={1} height={1}>
                                                        <use xlinkHref="#image0_5347_179719" transform="scale(0.01)" />
                                                    </pattern>
                                                    <image id="image0_5347_179719" width={100} height={100} xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAABpElEQVR4nO3cP24TURRG8fsspcgCWAZNOgqQ+JMmAQlR06aiYSXshgI6NpC09FQpUqAIy2k4NJECTuYVGWvuDe/8FvD0SUcje+TxREiSJEmSJEmSJEmSJEmSJGnHgMfAV+AzcJC9Z3jAKTcugafZm4YG/OBfRskEnHDbJfAse9uwgI/A760ov4Dn2duG1YnyInvbsIxSkFEKMkpBnSgvs7cNyygFGaWgTpRX2duGNRFlbZRERinIKAVNRNkAx9nbhmWUgoxSUCfK6+xtwzJKQRNRroA3uzi/7WDg+4j4FBGP5s950DYR8ba19mXOIbOCAHsR8TMi9uec8x9ZR8RRa+3bfQ9YzRywighmnqG/zArSWruKiJOION/NnAdtExHv5lwduofrD/VtftPKYIxCOjG8W1+aMQqZiLEGDrO3DacTw99ElmaMQoxRyEQMnzzJ0Inhs1lLM0YhnRg+dL00YxRijEKMUYgxCunE8J+4SzNGIcCHO2L44oAMwN71lbAdw1drZABWwIUxCgGOgO/AGfAke48kSZIkSZIkSZIkSZIkSVK+P8FCeQW4Jt9JAAAAAElFTkSuQmCC" />
                                                </defs>
                                            </svg>
                                        </div>

                                    </div>
                                </ButtonPrimary>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentInfo;
